import { render, staticRenderFns } from "./modalMassFreightBuilder.vue?vue&type=template&id=4e50f155&scoped=true"
import script from "./modalMassFreightBuilder.vue?vue&type=script&lang=js"
export * from "./modalMassFreightBuilder.vue?vue&type=script&lang=js"
import style0 from "./modalMassFreightBuilder.vue?vue&type=style&index=0&id=4e50f155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e50f155",
  null
  
)

export default component.exports